var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorizonN(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "19px",
    viewBox: "0 0 33 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "horizon_n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "library",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04a_book_reader_settings",
    transform: "translate(-608.000000, -721.000000)",
    fill: "#AAAAAA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.5,721 L639.5,721 C640.328427,721 641,721.671573 641,722.5 C641,723.328427 640.328427,724 639.5,724 L609.5,724 C608.671573,724 608,723.328427 608,722.5 C608,721.671573 608.671573,721 609.5,721 Z M609.5,729 L632.24,729 C633.068427,729 633.74,729.671573 633.74,730.5 C633.74,731.328427 633.068427,732 632.24,732 L609.5,732 C608.671573,732 608,731.328427 608,730.5 C608,729.671573 608.671573,729 609.5,729 Z M609.5,737 L636.2,737 C637.028427,737 637.7,737.671573 637.7,738.5 C637.7,739.328427 637.028427,740 636.2,740 L609.5,740 C608.671573,740 608,739.328427 608,738.5 C608,737.671573 608.671573,737 609.5,737 Z",
    id: "horizon_n"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizonN);
export default __webpack_public_path__ + "static/media/horizon_n.17244c0b8ed8e4ccaf52e0a419163776.svg";
export { ForwardRef as ReactComponent };